import { axios, multiPartAxios } from "../../lib/axios";
import { NewCustomerValue } from "../../components/NewCustomerModal/NewCustomerWrapper";
import { IPostUpdateOpeningDetail } from "../post/types";
import { UpdatedStaff } from "./types";

export const UpdateUser = (id: number, data: UpdatedStaff) => {
  return multiPartAxios.put(`/api/v1/user/update/${id}`, data);
};

export const UpdatePatronDetail = (id: number, data: NewCustomerValue) => {
  return axios.put(`/api/v1/customer/update/${id}`, data);
};

export const UpdateSpecificOpeningStockDetail = (
  data: IPostUpdateOpeningDetail,
  id: number
) => {
  return axios.put(`api/v1/product_service/opening/stock-update/${id}`, data);
};
